import {
  Mitarbeiter_DeleteRotationsplanMutation,
  Mitarbeiter_DeleteRotationsplanMutationVariables,
} from '@/gql/graphql';
import { toast } from '@/hooks/use-toast';
import { ApolloLink } from '@apollo/client';
import { TFunction } from 'i18next';
import { NavigateFunction } from 'react-router-dom';
import * as Sentry from '@sentry/react';

export function handleDelete({
  setIsSubmitting,
  deleteRotationsplan,
  rotationsplanId,
  t,
  navigate,
}: {
  setIsSubmitting: (value: boolean) => void;
  deleteRotationsplan: (
    variables: Mitarbeiter_DeleteRotationsplanMutationVariables,
  ) => Promise<ApolloLink.Result<Mitarbeiter_DeleteRotationsplanMutation>>;
  rotationsplanId: string;
  t: TFunction<'translation', undefined>;
  navigate: NavigateFunction;
}) {
  setIsSubmitting(true);

  deleteRotationsplan({
    rotationsplanId,
  })
    .then((result) => {
      if (result.errors || result.data?.mitarbeiter_deleteRotationsplan.error) {
        toast({
          variant: 'destructive',
          description: t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.error',
          ),
        });
      } else {
        navigate(`/mitarbeiter/rotationsplaene/uebersicht`);
        toast({
          description: t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.success',
          ),
        });
      }
    })
    .catch((error) => {
      Sentry.captureException(error);
      toast({
        variant: 'destructive',
        title: t(
          'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.error',
        ),
      });
    })
    .finally(() => setIsSubmitting(false));
}
